import React, { useEffect, useState } from 'react'
import ImageAndParagraph from '../../components/imageAndParagraph/imageAndParagraph'
import { useTheme } from '@chakra-ui/react';
import path26 from '../../innerAsstes/Seccion trayecto/Recurso 26trayecto.png';
import PathAndText from '../../components/professionalPath/pathAndText/pathAndText';
import PathSteps from '../../components/professionalPath/pathSteps/pathSteps';
import CarouselForComponents from '../../components/carouselCustom/carouselCustom';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../App';
import { getCompositions } from '../../utils/dataFetch';

export default function ProfessionalPath() {
  const navigate = useNavigate()
  const [compositions, setCompositions] = useState([]);
  const theme = useTheme();
  const {isMobile, setSelectedCategory} = useAppContext();
  const style = styles(theme, isMobile);

  useEffect(() =>{
    getCompositions().then(setCompositions)
  },[]);
  
  return (
    <div style={style.container}>
      <div style={style.container1} className="sansation-bold" >
        <ImageAndParagraph
          imgSrc={path26}
          titleFirst={"Potenciamos juntos"}
          titleSecond={"TU TRAYECTO PROFESIONAL"}
          description={`¿Sabías que además de realizar cursos individuales, llevando a cabo otros cursos podés alcanzar DIPLOMATURAS O SECRETARIADOS?`}
          customStyles={style.imageAndTextStyle}
        />
        <p style={style.description}>
          Nuestros cursos están diseñados para que COMPLEMENTADOS ENTRE SÍ,
          alcances Diplomados y Secretariados.
        </p>
        <p style={style.description2}>
          CONOCÉ TODOS LOS TRAYECTOS PROFESIONALES
        </p>
        <CarouselForComponents qtyPerView={isMobile? 1 : 3} customStyles={style.pathsRow}>
          {
            compositions?.map(({NombreComposicion, IdComposicion}, index) => (
              <p onClick={() =>{setSelectedCategory(null); navigate(`/categorias-general/${ IdComposicion !== "0"? 'Trayecto%20Profesional' : 'Cursos'}`)}} 
                style={style.path}
              >
                {NombreComposicion}
              </p>
            ))
          }
        </CarouselForComponents>
      </div>
      <PathAndText />
      <PathSteps />
    </div>
  );
}
const styles = (theme, isMobile) => ({
  container: {},
  container1: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "4vh",
    backgroundColor: theme.background.primary,
  },
  description: {
    width: isMobile? "100%":"50%",
    textAlign: "center",
    fontSize: isMobile? "1.2rem":"2.5rem",
    color: theme.color.text.primary,
  },
  description2: {
    textAlign: "center",
    fontSize: isMobile? "1.2rem":"1.8rem",
    color: theme.color.text.secondary,
  },
  imageAndTextStyle: {
    container: {
      width: "90%",
      margin: 0,
      padding: 0,
      flexDirection: isMobile? "column":"row-reverse",
    },
    img: {
      width: isMobile? "100%":"30%",
      height: "80%",
    },
    description: {
      width: isMobile? "100%":"85%",
    },
    textContainer: {
      width: isMobile? "100%":"50%",
    },
    title1: {
      fontSize: isMobile? "2rem":"4.5rem",
      color: theme.color.text.secondary,
    },
    title2: {
      fontSize: isMobile? "2rem":"4rem",
    },
  },
  pathsRow: {
    display: "flex",
    width: "80%",
    height: "10vh",
    justifyContent: isMobile? "center":"space-around",
    fontSize: "1.5rem",
    flexDirection: "row",
    marginTop: "1.5rem",
    color: theme.color.text.primary,
  },
  path: {
    paddingRight: "1vw",
    paddingLeft: "1vw",
    cursor: "pointer"
  },
});